let url = ''
let preffixImg = ''
let manageUrl = ''
if (process.env.NODE_ENV === 'production') {
  console.log('process.env.type')
  console.log(process)
  if (process.env.type === 'testing') {
    url = 'http://192.168.0.70:8082/spark_manage_web'
    preffixImg = 'http://192.168.0.70/image/'
    manageUrl = 'http://192.168.0.70/manager/'
  } else if (process.env.type === 'pressure') {
    url = 'https://yf.zpspark.com/spark_manage_web'
    preffixImg = 'https://yf.zpspark.com//image/'
    manageUrl = 'https://yf.zpspark.com/manager/'
  } else {
    url = 'https://www.zpspark.com/spark_manage_web'
    preffixImg = 'https://www.zpspark.com/image/'
    manageUrl = 'https://www.zpspark.com/manager/'
  }
} else {
  url = 'http://192.168.0.70:8082/spark_manage_web'
  // url = 'http://192.168.0.155:8080/spark_manage_web'
  // url = 'https://yf.zpspark.com/spark_manage_web'
  preffixImg = 'http://192.168.0.70/image/'
  manageUrl = 'http://192.168.0.70/manager/'
}
export { url, preffixImg, manageUrl }



// WEBPACK FOOTER //
// ./src/api/common.js